// extracted by mini-css-extract-plugin
export default {"App":"App-module-App-e3a20ca8cad3d9e18e19","anchorWrapper":"App-module-anchorWrapper-fa59a99df941a2fb836a"};